angular.module('unergie.main')
.controller('withoutPrmEstimationModalCtrl', ($scope, $uibModalInstance, lastWithoutPrmEstimation) => {
    $scope.lastWithoutPrmEstimation = lastWithoutPrmEstimation
    $scope.totalAnnually = Math.floor(lastWithoutPrmEstimation.timetables[1].sleeked * 1200) / 100
    $scope.subscription = lastWithoutPrmEstimation.timetables[1].subscription.toFixed(0)
    $scope.firstAmount = lastWithoutPrmEstimation.timetables[0].amountWithModif.toFixed(2)
    $scope.firstDate = moment(`${lastWithoutPrmEstimation.timetables[0].month}/${lastWithoutPrmEstimation.timetables[0].year}`, 'M/YYYY').format('MMM YYYY')
    $scope.close = $uibModalInstance.dismiss
})
